import ListItemText from '@mui/material/ListItemText';
import { ReactNode } from 'react';

export interface ListSectionItemTextProps {
  label: ReactNode;
  subtitle: ReactNode;
}

export const ListSectionItemText = ({ label, subtitle }: ListSectionItemTextProps) => {
  return <ListItemText primary={label} secondary={subtitle} />;
};
